import { render, staticRenderFns } from "./FormsPage.vue?vue&type=template&id=141a6cec&scoped=true"
import script from "./FormsPage.vue?vue&type=script&lang=ts"
export * from "./FormsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141a6cec",
  null
  
)

export default component.exports